import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalBGWrapper: theme => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xs};
    padding: ${theme.spacing.xs};
    margin: ${theme.spacing.md} 0;
    border-radius: ${theme.border.radius.md};
    background-color: ${theme.colors.brand.primary[100]};
  `,
  modalContent: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    padding: ${theme.spacing.md} 0;
  `,
  modalSoonText: theme => css`
    margin-bottom: ${theme.spacing.sm};
  `,
})

export default useStyles
